import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageSEO } from '../hooks/usePageSEO';
import './Projects.css';

const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedProject, setSelectedProject] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(null);
  const location = useLocation();

  usePageSEO(
    'Our Projects | Mobile App & Website Development Portfolio - GoToBusiness',
    'View our portfolio of mobile app development, website development & software development projects. Flutter apps, web apps, CRM, healthcare apps. GoToBusiness Noida.'
  );

  // Check for category parameter in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const categoryParam = urlParams.get('category');
    
    if (categoryParam) {
      // Map service names to project categories
      const categoryMapping = {
        'website-development': 'Website Development',
        'mobile-applications': 'Mobile Application',
        'software-solutions': 'Software Solution',
        'unity-gaming': 'Unity Gaming'
      };
      
      const mappedCategory = categoryMapping[categoryParam];
      if (mappedCategory) {
        setSelectedCategory(mappedCategory);
      }
    }
  }, [location]);

  const projects = [
   
    {
      id: 1,
      title: "Rama Hospital Management App",
      category: "Mobile Application",
      technologies: ["Flutter", "Firebase", "Java", "Healthcare APIs"],
      description: "Hospital management application designed to streamline operations for both patients and healthcare providers. Features appointment booking, patient records access, and real-time hospital updates with announcements and alerts.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/Hospital/homescreen.jpg`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/Hospital/splash_screen.jpg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Hospital/splash_screen1.jpg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Hospital/homescreen.jpg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Hospital/Profile_screen.jpg`
      ],
      status: "Completed"
    },
    {
      id: 2,
      title: "MedicleanX - Hospital Hygiene Management",
      category: "Mobile Application",
      technologies: ["Flutter", "Java", "Mysql", "Image Upload"],
      description: "This application was developed for hospitals to maintain hygiene standards. Features complaint management system, floor-wise cleaning tracking, image documentation, and admin dashboard for monitoring sanitation activities.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/MedicCleax/1741002607398.jpg`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/MedicCleax/1741002607398.jpg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/MedicCleax/1741002634980.jpg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/MedicCleax/1741002769880.jpg`
      ],
      status: "Completed"
    },
    {
      id: 3,
      title: "CRM Application - Employee & Client Management",
      category: "Mobile Application",
      technologies: ["Flutter", "Java", "MySql", "REST APIs"],
      description: "A powerful and easy-to-use CRM platform designed for both employees and clients. Helps streamline work, improve communication, and manage daily tasks directly from mobile device. Features leave management, payslip downloads, and client communication tools.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm1.webp`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm1.webp`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm2.webp`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm3.webp`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm4.webp`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm5.webp`,
        `${process.env.PUBLIC_URL || ''}/images/projects/Crm/crm6.webp`
      ],
      playStoreLink: "https://play.google.com/store/apps/details?id=com.rohit.brtcrm",
      status: "Completed"
    },
    {
      id: 10,
      title: "Securea — Secure you First",
      category: "Mobile Application",
      technologies: ["Flutter", "Firebase", "Java"],
      description: "Securea — Secure you First. A mobile security-focused application designed to keep users protected with reliable safety features and a clean, easy-to-use experience.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/seccurea/secure1.jpeg`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/seccurea/secure1.jpeg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/seccurea/secure2.jpeg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/seccurea/secure3.jpeg`,
        `${process.env.PUBLIC_URL || ''}/images/projects/seccurea/secure4.jpeg`
      ],
      status: "Completed"
    },
    
   
    {
      id: 4,
      title: "Inventory Management System",
      category: "Software Solution",
      technologies: ["Java", "Spring Boot", "MySQL", "Angular"],
      description: "Enterprise-level inventory management system with barcode scanning, reporting, and multi-location support.",
      image: "📦",
      status: "Completed"
    },
    {
      id: 5,
      title: "Adventure Quest Game",
      category: "Unity Gaming",
      technologies: ["Unity 3D", "C#", "Blender", "Photon Network"],
      description: "3D adventure game with multiplayer support, quest system, and immersive gameplay mechanics.",
      image: "🎮",
      status: "In Development"
    },
  
    {
      id: 6,
      title: "Restaurant Management System",
      category: "Website Development",
      technologies: ["Vue.js", "Laravel", "PostgreSQL", "Socket.io"],
      description: "Complete restaurant management solution with online ordering, table booking, and kitchen management.",
      image: "🍽️",
      status: "Completed"
    },
    {
      id: 7,
      title: "Aurelia Dermatology — Skin Clinic",
      category: "Website Development",
      technologies: ["React", "Next.js", "Vercel"],
      description: "Modern dermatology clinic website for Aurelia Dermatology. Clean branding, service showcase, and a polished patient-facing experience for skin care consultations and clinic information.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi1.png`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi1.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi2.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi3.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi4.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi5.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/medi_connect/medi6.png`
      ],
      liveLink: "https://medi-connect-puce.vercel.app/",
      status: "Completed"
    },
    {
      id: 8,
      title: "Silicon Computers — Parts & Repairing",
      category: "Website Development",
      technologies: ["React", "Next.js", "Vercel"],
      description: "Business website for Silicon Computers covering computer parts, repairing services, and store information with a clean product-focused layout.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/computer/com0.png`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/computer/com0.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/computer/comp1.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/computer/comp2.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/computer/comp3.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/computer/comp4.png`
      ],
      liveLink: "https://silicon-computer.vercel.app/",
      status: "Completed"
    },
    {
      id: 9,
      title: "Drishti — Photography Studio",
      category: "Website Development",
      technologies: ["React", "Next.js", "Vercel"],
      description: "Elegant photography studio website for Drishti. Portfolio-driven layout showcasing visual storytelling, services, and a refined brand experience for clients seeking professional photography.",
      image: `${process.env.PUBLIC_URL || ''}/images/projects/photography/photo1.png`,
      gallery: [
        `${process.env.PUBLIC_URL || ''}/images/projects/photography/photo1.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/photography/photo2.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/photography/photo3.png`,
        `${process.env.PUBLIC_URL || ''}/images/projects/photography/photo4.png`
      ],
      liveLink: "https://drishti-studio-ten.vercel.app/",
      status: "Completed"
    },
   
  ];

  const categories = ["All", "Website Development", "Mobile Application", "Software Solution", "Unity Gaming"];

  const filteredProjects = selectedCategory === "All" 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  const openGallery = (project) => {
    setSelectedProject(project);
    setPreviewIndex(null);
  };

  const closeGallery = () => {
    setSelectedProject(null);
    setPreviewIndex(null);
  };

  const openPreview = (index) => {
    setPreviewIndex(index);
  };

  const closePreview = () => {
    setPreviewIndex(null);
  };

  const showPrevImage = () => {
    if (!selectedProject?.gallery) return;
    setPreviewIndex((prev) =>
      prev === 0 ? selectedProject.gallery.length - 1 : prev - 1
    );
  };

  const showNextImage = () => {
    if (!selectedProject?.gallery) return;
    setPreviewIndex((prev) =>
      prev === selectedProject.gallery.length - 1 ? 0 : prev + 1
    );
  };

  useEffect(() => {
    if (previewIndex === null || !selectedProject?.gallery) return;

    const galleryLength = selectedProject.gallery.length;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        setPreviewIndex((prev) => (prev === 0 ? galleryLength - 1 : prev - 1));
      }
      if (e.key === 'ArrowRight') {
        setPreviewIndex((prev) => (prev === galleryLength - 1 ? 0 : prev + 1));
      }
      if (e.key === 'Escape') {
        setPreviewIndex(null);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [previewIndex, selectedProject]);

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const diff = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) showPrevImage();
      else showNextImage();
    }
    setTouchStartX(null);
  };

  return (
    <div className="projects">
      <section className="projects-hero">
        <div className="container">
          <h1>Our Projects</h1>
          <p>Explore our portfolio of successful digital solutions</p>
        </div>
      </section>

      <section className="projects-content section">
        <div className="container">
          {/* Filter Buttons */}
          <div className="filter-buttons">
            {categories.map(category => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="projects-grid">
            {filteredProjects.map(project => (
              <div key={project.id} className="project-card card">
                <div className="project-image">
                  {project.image.includes('/images/') ? (
                    <img 
                      src={project.image} 
                      alt={project.title} 
                      className={`project-screenshot${project.category === 'Mobile Application' ? ' project-screenshot--mobile' : ''}`}
                      onClick={() => project.gallery && openGallery(project)}
                      style={{ cursor: project.gallery ? 'pointer' : 'default' }}
                    />
                  ) : (
                    <span className="project-icon">{project.image}</span>
                  )}
                  <div className="project-status">
                    <span className={`status ${project.status.toLowerCase().replace(' ', '-')}`}>
                      {project.status}
                    </span>
                  </div>
                  {project.gallery && (
                    <div className="gallery-indicator">
                      📷 {project.gallery.length} photos
                    </div>
                  )}
                </div>
                
                <div className="project-content">
                  <div className="project-category">{project.category}</div>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  
                  <div className="project-technologies">
                    <h4>Technologies Used:</h4>
                    <div className="tech-tags">
                      {project.technologies.map((tech, index) => (
                        <span key={index} className="tech-tag">{tech}</span>
                      ))}
                    </div>
                  </div>
                  
                  {(project.playStoreLink || project.liveLink) && (
                    <div className="project-links">
                      {project.playStoreLink && (
                        <a 
                          href={project.playStoreLink} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="play-store-btn"
                        >
                          📱 View on Play Store
                        </a>
                      )}
                      {project.liveLink && (
                        <a 
                          href={project.liveLink} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="play-store-btn live-link-btn"
                        >
                          🌐 View Live Website
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Modal */}
      {selectedProject && (
        <div className="gallery-modal" onClick={closeGallery}>
          <div className="gallery-content" onClick={(e) => e.stopPropagation()}>
            <div className="gallery-header">
              <h3>{selectedProject.title}</h3>
              <button className="close-btn" onClick={closeGallery}>×</button>
            </div>
            <div className="gallery-grid">
              {selectedProject.gallery.map((image, index) => (
                <img 
                  key={index} 
                  src={image} 
                  alt={`${selectedProject.title} screenshot ${index + 1}`}
                  className="gallery-image"
                  onClick={() => openPreview(index)}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Fullscreen Image Preview */}
      {selectedProject && previewIndex !== null && (
        <div className="image-preview-modal" onClick={closePreview}>
          <button
            className="preview-close-btn"
            onClick={closePreview}
            aria-label="Close preview"
          >
            ×
          </button>

          <button
            className="preview-nav-btn preview-prev"
            onClick={(e) => {
              e.stopPropagation();
              showPrevImage();
            }}
            aria-label="Previous image"
          >
            ‹
          </button>

          <div
            className="preview-image-wrap"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <img
              src={selectedProject.gallery[previewIndex]}
              alt={`${selectedProject.title} preview ${previewIndex + 1}`}
              className="preview-image"
            />
            <div className="preview-counter">
              {previewIndex + 1} / {selectedProject.gallery.length}
            </div>
          </div>

          <button
            className="preview-nav-btn preview-next"
            onClick={(e) => {
              e.stopPropagation();
              showNextImage();
            }}
            aria-label="Next image"
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default Projects;